(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-faq"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     <fc-faq> — exclusive FAQ accordion.

     Opening a question closes the currently open one. The open/close motion
     is pure CSS (grid-template-rows 0fr -> 1fr), so this only toggles the
     is-open class and keeps aria-expanded in sync.
     -------------------------------------------------------------------------- */

  if (!customElements.get('fc-faq')) {
    customElements.define('fc-faq', class FcFaq extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-fc-faq-toggle]');
          if (!button) return;

          const item = button.closest('.fc-faq__item');
          const opening = !item.classList.contains('is-open');

          const open = this.querySelector('.fc-faq__item.is-open');
          if (open) this.setOpen(open, false);
          if (opening) this.setOpen(item, true);
        });
      }

      setOpen(item, open) {
        item.classList.toggle('is-open', open);
        item.querySelector('[data-fc-faq-toggle]').setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-anchor"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     FC PDP Anchor — smooth scroll + scroll spy

     Each tab carries the CSS class of the section it points at. On init the
     class is resolved to a real element, that element is given an id (unless
     it already has one) and the tab's href is pointed at it, so every tab is a
     real link. Clicking scrolls smoothly, allowing for the theme's sticky
     header and for this bar's own height when it is sticky. While scrolling,
     the tab for the section currently in view is marked aria-current.
     -------------------------------------------------------------------------- */

  (function () {
    'use strict';

    if (customElements.get('fc-pdp-anchor')) return;

    var HOLD_MS = 1000;

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function scrollBehavior() {
      return reducedMotion() ? 'auto' : 'smooth';
    }

    var STUCK_CLASS = 'fc-pdp-anchor-section--stuck';
    var HIDDEN_CLASS = 'fc-pdp-anchor-section--hidden';
    var ANIMATE_CLASS = 'fc-pdp-anchor-section--animate';

    /* The theme's sticky header, counted only while it is pinned and visible.
       Mirrors the state StickyHeader sets in sections/header.liquid, so the two
       can never disagree about how much room is taken at the top. */
    function headerHeight() {
      var header = document.querySelector('.shopify-section-header-sticky');
      if (!header || header.classList.contains('shopify-section-header-hidden')) return 0;
      return header.getBoundingClientRect().height;
    }

    function scrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    class FcPdpAnchor extends HTMLElement {
      connectedCallback() {
        this.entries = [];
        this.holdUntil = 0;
        this.frame = null;
        this.spyEnabled = this.dataset.fcAnchorSpy === 'true';

        // 'none' | 'always' | 'header'
        this.stickyMode = this.dataset.fcAnchorSticky || 'none';
        this.host = this.closest('.fc-pdp-anchor-section') || this;
        this.bounds = { top: 0, bottom: 0 };
        this.lastScroll = scrollY();

        this.onClick = this.handleClick.bind(this);
        this.onScroll = this.handleScroll.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onRebuild = this.build.bind(this);

        this.addEventListener('click', this.onClick);
        window.addEventListener('resize', this.onResize, { passive: true });

        // Sections render in any order, so a target may not exist yet on init.
        window.addEventListener('load', this.onRebuild);
        document.addEventListener('shopify:section:load', this.onRebuild);

        this.build();

        // One scroll listener drives both the spy and the sticky behaviour.
        if (this.spyEnabled || this.stickyMode !== 'none') {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.handleScroll();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('load', this.onRebuild);
        document.removeEventListener('shopify:section:load', this.onRebuild);
        if (this.frame) cancelAnimationFrame(this.frame);

        // The sticky state lives on the section wrapper, which outlives this
        // element in the theme editor — leave it exactly as it was found.
        this.host.classList.remove(STUCK_CLASS, HIDDEN_CLASS, ANIMATE_CLASS);
        this.host.style.removeProperty('--fc-pdp-anchor-sticky-top');
      }

      /* Everything pinned above the destination: the header, this bar when it
         is sticky, and the merchant's extra breathing room.

         The bar's own height counts whenever sticky is switched on at all, not
         just while it happens to be pinned right now. A tab clicked before the
         bar has pinned still scrolls down past its resting point, so the bar
         will be covering the top of the destination by the time it lands. The
         height reads 0 on desktop, where the bar is display:none. */
      get offset() {
        var offset = parseFloat(this.dataset.fcAnchorOffset) || 0;
        offset += headerHeight();

        if (this.stickyMode !== 'none') {
          offset += this.getBoundingClientRect().height;
        }
        return offset;
      }

      /* Accepts "fc-faq-section", ".fc-faq-section" or "#some-id". */
      static resolve(value) {
        var raw = (value || '').trim();
        if (!raw) return null;

        var first = raw.charAt(0);
        var selector = first === '.' || first === '#' ? raw : '.' + raw;

        try {
          return document.querySelector(selector);
        } catch (error) {
          return null;
        }
      }

      build() {
        this.entries = [];

        this.querySelectorAll('[data-fc-anchor-target]').forEach((tab) => {
          var item = tab.closest('.fc-pdp-anchor__item');
          var target = FcPdpAnchor.resolve(tab.dataset.fcAnchorTarget);

          // Nothing to point at — drop the tab rather than leave a dead one.
          if (!target || target === this || this.contains(target)) {
            if (item) item.hidden = true;
            return;
          }

          if (item) item.hidden = false;

          // Keep an id the section already has; only add one when it has none.
          if (!target.id) target.id = tab.dataset.fcAnchorId;
          tab.setAttribute('href', '#' + target.id);

          this.entries.push({ tab: tab, target: target });
        });

        this.hidden = this.entries.length === 0;
        this.measure();
        this.updateStickyTop();
      }

      /* ----------------------------------------------------------------------
         Sticky — the same shape as StickyHeader in sections/header.liquid:
         the bar is only pinned once you have scrolled past where it naturally
         sits, it resets when you scroll back above that point, and in 'header'
         mode it hides on the way down and reveals on the way up. On mobile the
         theme header always behaves that way (theme.config.mqlSmall), so
         'header' mode is what actually matches it on this mobile-only bar.
         ---------------------------------------------------------------------- */

      /* The bar's resting position in the document, measured with the sticky
         offset and the hide transform both taken off — either one would
         corrupt the reading. Only runs on build and resize, never per frame. */
      measure() {
        if (this.stickyMode === 'none') return;

        var list = this.host.classList;
        var wasStuck = list.contains(STUCK_CLASS);
        var wasHidden = list.contains(HIDDEN_CLASS);

        // Suspend the transition too, so restoring the classes below cannot
        // animate the bar back into place.
        list.remove(STUCK_CLASS, HIDDEN_CLASS, ANIMATE_CLASS);

        var box = this.host.getBoundingClientRect();
        var top = scrollY();
        this.bounds = { top: top + box.top, bottom: top + box.bottom };

        if (wasStuck) list.add(STUCK_CLASS, ANIMATE_CLASS);
        if (wasHidden) list.add(HIDDEN_CLASS);
      }

      /* A pinned bar parks below the sticky header, not underneath it. The
         variable goes on the section wrapper because that is the element the
         CSS actually sticks — custom properties inherit down, not up. */
      updateStickyTop() {
        if (this.stickyMode === 'none') return;
        this.host.style.setProperty('--fc-pdp-anchor-sticky-top', headerHeight() + 'px');
      }

      updateSticky() {
        if (this.stickyMode === 'none') return;

        var top = scrollY();
        var list = this.host.classList;
        var past = top > this.bounds.bottom;

        this.updateStickyTop();

        if (!past) {
          // Back at its resting place — drop every sticky class so the bar
          // cannot animate on the next pin, matching StickyHeader.reset().
          list.remove(STUCK_CLASS, HIDDEN_CLASS, ANIMATE_CLASS);
          this.lastScroll = top;
          return;
        }

        list.add(STUCK_CLASS, ANIMATE_CLASS);

        // A tab click scrolls the page downwards, which would otherwise make
        // the bar hide the instant it was used. Hold it open while that scroll
        // is still running.
        var held = Date.now() < this.holdUntil;

        if (this.stickyMode === 'header' && top > this.lastScroll && !held) {
          list.add(HIDDEN_CLASS);
        } else {
          list.remove(HIDDEN_CLASS);
        }

        this.lastScroll = top;
      }

      handleResize() {
        this.measure();
        this.updateStickyTop();
      }

      handleClick(event) {
        var tab = event.target.closest && event.target.closest('[data-fc-anchor-target]');
        if (!tab || !this.contains(tab)) return;

        var entry = this.entries.find((item) => item.tab === tab);
        if (!entry) return;

        event.preventDefault();

        //var top = entry.target.getBoundingClientRect().top + window.pageYOffset - this.offset;
        var top = entry.target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: Math.max(top, 0), behavior: scrollBehavior() });

        // Mark it straight away and hold the spy off until the scroll settles,
        // so the highlight does not flicker through the sections in between.
        this.setActive(tab);
        this.holdUntil = Date.now() + HOLD_MS;

        // Move focus to the destination so the jump is announced, without
        // permanently adding the section to the tab order.
        var hadTabIndex = entry.target.hasAttribute('tabindex');
        if (!hadTabIndex) entry.target.setAttribute('tabindex', '-1');
        entry.target.focus({ preventScroll: true });
        if (!hadTabIndex) entry.target.removeAttribute('tabindex');
      }

      handleScroll() {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;

          // Pinning runs on every frame; only the highlight is held back after
          // a click, so a click never freezes the bar in place.
          this.updateSticky();

          if (!this.spyEnabled || Date.now() < this.holdUntil) return;

          // A section becomes current once its top passes the line just below
          // whatever is pinned above it.
          var line = this.offset;
          var active = null;

          this.entries.forEach((entry) => {
            if (entry.target.getBoundingClientRect().top <= line) active = entry.tab;
          });

          // Above the first target — the first tab stays current.
          if (!active && this.entries.length) active = this.entries[0].tab;

          this.setActive(active);
        });
      }

      setActive(tab) {
        this.entries.forEach((entry) => {
          if (entry.tab === tab) {
            entry.tab.setAttribute('aria-current', 'true');
          } else {
            entry.tab.removeAttribute('aria-current');
          }
        });

        if (tab) this.reveal(tab);
      }

      /* Keeps the active tab in view once the merchant has added enough tabs
         to make the bar scroll sideways. */
      reveal(tab) {
        var list = this.querySelector('.fc-pdp-anchor__list');
        if (!list || list.scrollWidth <= list.clientWidth) return;

        var listBox = list.getBoundingClientRect();
        var tabBox = tab.getBoundingClientRect();
        var delta = tabBox.left + tabBox.width / 2 - (listBox.left + listBox.width / 2);

        if (Math.abs(delta) < 1) return;
        list.scrollBy({ left: delta, behavior: scrollBehavior() });
      }
    }

    customElements.define('fc-pdp-anchor', FcPdpAnchor);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-hotspot-icon"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     <fc-hotspot-icon> — keeps exactly one hotspot active.

     Desktop: clicking a marker swaps which popover is visible, and the bottom
              carousel scrolls its matching card into view. Selecting a carousel
              card does the reverse, and scrolling the carousel re-activates the
              marker whose card is nearest the centre. The carousel is also
              draggable, since a mouse has no swipe to offer it.
     Mobile:  the cards are a scroll-snapped rail; tapping a marker scrolls its
              card into view, and scrolling the rail re-activates the matching
              marker so the two stay in sync.
     -------------------------------------------------------------------------- */

  class FcHotspotIcon extends HTMLElement {
    connectedCallback() {
      this.markers = Array.from(this.querySelectorAll('[data-fc-hotspot-marker]'));
      this.cards = Array.from(this.querySelectorAll('[data-fc-hotspot-card]'));
      this.rail = this.querySelector('[data-fc-hotspot-rail]');
      this.carousel = this.querySelector('[data-fc-hotspot-carousel]');
      this.carouselCards = Array.from(this.querySelectorAll('[data-fc-hotspot-carousel-card]'));
      this.selects = Array.from(this.querySelectorAll('[data-fc-hotspot-select]'));

      if (!this.markers.length) return;

      this.activeIndex = 0;
      this.onMarkerClick = this.onMarkerClick.bind(this);
      this.onMarkerKeydown = this.onMarkerKeydown.bind(this);
      this.onRailScroll = this.onRailScroll.bind(this);
      this.onCarouselScroll = this.onCarouselScroll.bind(this);
      this.onSelectClick = this.onSelectClick.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onDragMove = this.onDragMove.bind(this);
      this.onDragEnd = this.onDragEnd.bind(this);
      this.onDragClick = this.onDragClick.bind(this);

      this.markers.forEach((marker) => {
        marker.addEventListener('click', this.onMarkerClick);
        marker.addEventListener('keydown', this.onMarkerKeydown);
      });

      /* The carousel card cannot be a button — it holds the quick-add form —
         so its stretched select button gets the marker's keyboard handling. */
      this.selects.forEach((select) => {
        select.addEventListener('click', this.onSelectClick);
        select.addEventListener('keydown', this.onMarkerKeydown);
      });

      if (this.rail) {
        this.rail.addEventListener('scroll', this.onRailScroll, { passive: true });
      }

      if (this.carousel) {
        this.carousel.addEventListener('scroll', this.onCarouselScroll, { passive: true });
        this.carousel.addEventListener('pointerdown', this.onDragStart);
        this.carousel.addEventListener('pointermove', this.onDragMove);
        this.carousel.addEventListener('pointerup', this.onDragEnd);
        this.carousel.addEventListener('pointercancel', this.onDragEnd);
        this.carousel.addEventListener('dragstart', this.onDragStart);
        /* Capture phase: the click has to be swallowed before it reaches the
           select button or the quick add sitting under the cursor. */
        this.carousel.addEventListener('click', this.onDragClick, true);
      }
    }

    disconnectedCallback() {
      this.markers.forEach((marker) => {
        marker.removeEventListener('click', this.onMarkerClick);
        marker.removeEventListener('keydown', this.onMarkerKeydown);
      });

      this.selects.forEach((select) => {
        select.removeEventListener('click', this.onSelectClick);
        select.removeEventListener('keydown', this.onMarkerKeydown);
      });

      if (this.rail) {
        this.rail.removeEventListener('scroll', this.onRailScroll);
      }

      if (this.carousel) {
        this.carousel.removeEventListener('scroll', this.onCarouselScroll);
        this.carousel.removeEventListener('pointerdown', this.onDragStart);
        this.carousel.removeEventListener('pointermove', this.onDragMove);
        this.carousel.removeEventListener('pointerup', this.onDragEnd);
        this.carousel.removeEventListener('pointercancel', this.onDragEnd);
        this.carousel.removeEventListener('dragstart', this.onDragStart);
        this.carousel.removeEventListener('click', this.onDragClick, true);
      }

      this.clearPending();
    }

    get isRail() {
      // The rail only scrolls below 768px; above it the cards are popovers.
      return window.matchMedia('(max-width: 767px)').matches;
    }

    onMarkerClick(event) {
      const index = Number(event.currentTarget.getAttribute('data-fc-hotspot-marker'));
      this.select(index, true);
    }

    onSelectClick(event) {
      const index = Number(event.currentTarget.getAttribute('data-fc-hotspot-select'));
      /* The card is already under the reader's cursor, so it is not re-centred
         out from under them — only the hotspot moves. */
      this.select(index, false);
    }

    onMarkerKeydown(event) {
      const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
      if (keys.indexOf(event.key) === -1) return;

      event.preventDefault();
      const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      const next = (this.activeIndex + step + this.markers.length) % this.markers.length;

      const fromSelect = event.currentTarget.hasAttribute('data-fc-hotspot-select');

      this.select(next, true);

      if (fromSelect && this.selects[next]) {
        this.selects[next].focus();
      } else {
        this.markers[next].focus();
      }
    }

    onRailScroll() {
      if (!this.isRail || !this.cards.length) return;

      if (this.railFrame) cancelAnimationFrame(this.railFrame);
      this.railFrame = requestAnimationFrame(() => this.syncTo(this.rail, this.cards));
    }

    onCarouselScroll() {
      if (this.isRail || !this.carouselCards.length) return;

      if (this.carouselFrame) cancelAnimationFrame(this.carouselFrame);
      this.carouselFrame = requestAnimationFrame(() =>
        this.syncTo(this.carousel, this.carouselCards)
      );
    }

    /* Whichever card is nearest the container's centre line becomes active. */
    syncTo(container, cards) {
      const containerRect = container.getBoundingClientRect();
      const centre = containerRect.left + containerRect.width / 2;
      let closest = 0;
      let smallest = Infinity;

      cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const distance = Math.abs(cardRect.left + cardRect.width / 2 - centre);
        if (distance < smallest) {
          smallest = distance;
          closest = index;
        }
      });

      /* A smooth scroll we started ourselves travels past every card in
         between; without this the hotspot would flicker through each of them
         on the way. The pending flag is released once the scroll arrives. */
      if (this.pendingContainer === container) {
        if (closest === this.activeIndex) this.clearPending();
        return;
      }

      if (closest !== this.activeIndex) this.select(closest, false);
    }

    /* Scrolls `card` to the centre of `container`, honouring reduced motion. */
    centre(container, card) {
      if (!container || !card) return;

      const containerRect = container.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const target =
        container.scrollLeft +
        (cardRect.left - containerRect.left) -
        (containerRect.width - cardRect.width) / 2;
      const reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.pendingContainer = container;
      /* Backstop: a scroll interrupted by the reader never arrives, so the
         flag is released on a timer as well. */
      clearTimeout(this.pendingTimer);
      this.pendingTimer = setTimeout(() => this.clearPending(), 800);

      container.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    clearPending() {
      clearTimeout(this.pendingTimer);
      this.pendingContainer = null;
    }

    /* ------------------------------------------------------------------ drag */

    onDragStart(event) {
      /* Also wired to `dragstart`, where the only job is to stop the browser
         from turning the gesture into a native drag. */
      if (event.type === 'dragstart') {
        event.preventDefault();
        return;
      }

      /* Touch and pen already scroll the rail natively, and taking the pointer
         from them would kill the momentum. */
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      this.dragPointerId = event.pointerId;
      this.dragOriginX = event.clientX;
      this.dragOriginScroll = this.carousel.scrollLeft;
      this.dragDistance = 0;
      this.dragging = false;

      /* A drag is the reader taking over from a scroll we started. */
      this.clearPending();
    }

    onDragMove(event) {
      if (this.dragPointerId !== event.pointerId) return;

      const delta = event.clientX - this.dragOriginX;

      /* 4px of slack so a click with a shaky hand is still a click. */
      if (!this.dragging) {
        if (Math.abs(delta) < 4) return;

        this.dragging = true;
        this.carousel.classList.add('is-dragging');
        this.carousel.setPointerCapture(event.pointerId);
      }

      event.preventDefault();
      this.dragDistance = Math.abs(delta);
      this.carousel.scrollLeft = this.dragOriginScroll - delta;
    }

    onDragEnd(event) {
      if (this.dragPointerId !== event.pointerId) return;

      if (this.carousel.hasPointerCapture(event.pointerId)) {
        this.carousel.releasePointerCapture(event.pointerId);
      }

      this.dragPointerId = null;
      this.dragging = false;
      this.carousel.classList.remove('is-dragging');
    }

    onDragClick(event) {
      if (this.dragDistance <= 4) return;

      /* The click that closes a drag would otherwise select the card the
         reader happened to release over. */
      event.preventDefault();
      event.stopPropagation();
      this.dragDistance = 0;
    }

    select(index, scrollIntoView) {
      this.activeIndex = index;

      this.markers.forEach((marker, i) => {
        marker.classList.toggle('is-active', i === index);
        /* Without cards the marker controls nothing, so it has no expanded state. */
        if (this.cards.length) {
          marker.setAttribute('aria-expanded', i === index ? 'true' : 'false');
        }
      });

      this.cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === index);
      });

      this.carouselCards.forEach((card, i) => {
        card.classList.toggle('is-active', i === index);
      });

      this.selects.forEach((select, i) => {
        select.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      if (!scrollIntoView) return;

      if (this.isRail) {
        this.centre(this.rail, this.cards[index]);
      } else {
        this.centre(this.carousel, this.carouselCards[index]);
      }
    }
  }

  if (!customElements.get('fc-hotspot-icon')) {
    customElements.define('fc-hotspot-icon', FcHotspotIcon);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-lookbook"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     <fc-pdp-lookbook> — drives the mobile carousel only.

     Above 768px the rail is a static mosaic and the arrows are hidden, so the
     element does nothing but stay out of the way. Below 768px the arrows step
     the rail by one slide and disable themselves at each end.
     -------------------------------------------------------------------------- */

  class FcPdpLookbook extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-fc-lookbook-rail]');
      this.prev = this.querySelector('[data-fc-lookbook-prev]');
      this.next = this.querySelector('[data-fc-lookbook-next]');

      if (!this.rail || (!this.prev && !this.next)) return;

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);

      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });

      this.syncArrows();
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.rail) this.rail.removeEventListener('scroll', this.onScroll);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    }

    get slides() {
      return Array.from(this.rail.querySelectorAll('[data-fc-lookbook-slide]'));
    }

    /* One slide plus one gap — read from the DOM so a changed slide width or
       gap setting needs no JS change. The slides are laid out with the `order`
       property, so DOM order is not visual order: sort by position first. */
    get step() {
      const lefts = this.slides
        .map((slide) => slide.getBoundingClientRect())
        /* Panels hidden on mobile measure 0 and would collapse the step. */
        .filter((rect) => rect.width > 0)
        .map((rect) => rect.left)
        .sort((a, b) => a - b);

      if (lefts.length < 2) return this.rail.clientWidth;

      const distance = Math.abs(lefts[1] - lefts[0]);

      return distance > 0 ? distance : this.rail.clientWidth;
    }

    scrollByStep(direction) {
      const reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.rail.scrollBy({
        left: this.step * direction,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    onPrev() {
      this.scrollByStep(-1);
    }

    onNext() {
      this.scrollByStep(1);
    }

    onScroll() {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.syncArrows());
    }

    syncArrows() {
      const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
      const position = this.rail.scrollLeft;

      /* 1px of slack absorbs sub-pixel scroll positions on fractional DPRs. */
      if (this.prev) this.prev.disabled = position <= 1;
      if (this.next) this.next.disabled = position >= maxScroll - 1;
    }
  }

  if (!customElements.get('fc-pdp-lookbook')) {
    customElements.define('fc-pdp-lookbook', FcPdpLookbook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-product-info"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     FC PDP Product Info — collapsible panels

     Height is animated explicitly (0 <-> scrollHeight <-> auto) so opening and
     closing are symmetrical and the panel still reflows when its content or the
     viewport changes. Video playback is handled by the theme's <deferred-media>
     custom element (assets/global.js), so nothing is duplicated here.

     Each open panel is additionally capped at the media height (set in CSS from
     the section settings). The cap is read back from the rendered element so the
     breakpoint logic lives in one place, and the Read more toggle is only
     revealed when the content actually exceeds it.
     -------------------------------------------------------------------------- */

  (function () {
    'use strict';

    var ROOT_SELECTOR = '.fc-pdp-product-info';
    var ITEM_SELECTOR = '[data-fc-accordion-item]';
    var READY_ATTR = 'data-fc-accordion-ready';

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function parts(item) {
      return {
        trigger: item.querySelector('[data-fc-accordion-trigger]'),
        panel: item.querySelector('[data-fc-accordion-panel]')
      };
    }

    function setOpen(item, open, animate) {
      var p = parts(item);
      if (!p.trigger || !p.panel) return;

      item.setAttribute('data-open', open ? 'true' : 'false');
      p.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (!animate || prefersReducedMotion()) {
        p.panel.style.height = open ? 'auto' : '0px';
        return;
      }

      var target = p.panel.scrollHeight;

      if (open) {
        p.panel.style.height = '0px';
        // Force layout so the browser registers the start height.
        void p.panel.offsetHeight;
        p.panel.style.height = target + 'px';
      } else {
        p.panel.style.height = target + 'px';
        void p.panel.offsetHeight;
        p.panel.style.height = '0px';
      }
    }

    /* ----------------------------------------------------------- single open */

    function root(item) {
      return item.closest ? item.closest(ROOT_SELECTOR) : null;
    }

    function isSingleOpen(scope) {
      return !!scope && scope.getAttribute('data-fc-single-open') !== 'false';
    }

    function items(scope) {
      return Array.prototype.slice.call(scope.querySelectorAll(ITEM_SELECTOR));
    }

    function closeSiblings(item, animate) {
      var scope = root(item);
      if (!isSingleOpen(scope)) return;

      items(scope).forEach(function (other) {
        if (other !== item && other.getAttribute('data-open') === 'true') {
          setOpen(other, false, animate);
        }
      });
    }

    // Several blocks can be flagged "open by default" in the editor — with one
    // panel at a time, only the first of them may stay open on load.
    function enforceSingleOpen(scope) {
      var container = scope && scope.querySelectorAll ? scope : document;
      var roots = Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR));

      if (container.matches && container.matches(ROOT_SELECTOR)) {
        roots.push(container);
      }

      roots.forEach(function (node) {
        if (!isSingleOpen(node)) return;

        var kept = false;
        items(node).forEach(function (item) {
          if (item.getAttribute('data-open') !== 'true') return;
          if (kept) {
            setOpen(item, false, false);
          } else {
            kept = true;
          }
        });
      });
    }

    /* ---------------------------------------------------------------- clamp */

    function clampParts(item) {
      return {
        clamp: item.querySelector('[data-fc-clamp]'),
        content: item.querySelector('[data-fc-clamp-content]'),
        toggle: item.querySelector('[data-fc-clamp-toggle]'),
        label: item.querySelector('[data-fc-clamp-label]')
      };
    }

    function clampExpanded(c) {
      return c.toggle.getAttribute('aria-expanded') === 'true';
    }

    // The cap only ever lives in CSS. Drop any inline override, read the height
    // back, then restore — all within one frame, so nothing is painted.
    function clampCap(clamp) {
      var inline = clamp.style.maxHeight;
      if (!inline) return clamp.clientHeight;

      clamp.style.maxHeight = '';
      var cap = clamp.clientHeight;
      clamp.style.maxHeight = inline;
      return cap;
    }

    function setClampOpen(item, open, animate) {
      var c = clampParts(item);
      if (!c.clamp || !c.content || !c.toggle) return;

      c.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      c.clamp.setAttribute('data-fc-clamped', open ? 'false' : 'true');

      if (c.label) {
        var next = c.toggle.getAttribute(open ? 'data-less-label' : 'data-more-label');
        if (next) c.label.textContent = next;
      }

      // Let the surrounding accordion grow with the new height — it may still be
      // sitting on the pixel height left over from its own opening transition.
      var panel = item.querySelector('[data-fc-accordion-panel]');
      if (panel && item.getAttribute('data-open') === 'true') {
        panel.style.height = 'auto';
      }

      if (!animate || prefersReducedMotion()) {
        c.clamp.style.maxHeight = open ? 'none' : '';
        return;
      }

      var start = c.clamp.clientHeight;

      c.clamp.style.maxHeight = start + 'px';
      // Force layout so the browser registers the start height.
      void c.clamp.offsetHeight;
      // Closing falls back to the CSS cap so the breakpoint stays authoritative.
      c.clamp.style.maxHeight = open ? c.content.offsetHeight + 'px' : '';
    }

    function measureClamp(item) {
      var c = clampParts(item);
      if (!c.clamp || !c.content || !c.toggle) return;

      var overflows = c.content.offsetHeight > clampCap(c.clamp) + 1;
      c.toggle.hidden = !overflows;

      if (clampExpanded(c)) {
        // Content shrank back under the cap — nothing left to expand.
        if (!overflows) setClampOpen(item, false, false);
        return;
      }

      c.clamp.setAttribute('data-fc-clamped', overflows ? 'true' : 'false');
    }

    function bindClamp(item) {
      var c = clampParts(item);
      if (!c.clamp || !c.content || !c.toggle) return;

      // Settle to `none` once expanded so the panel keeps growing with reflow.
      c.clamp.addEventListener('transitionend', function (event) {
        if (event.target !== c.clamp || event.propertyName !== 'max-height') return;
        if (clampExpanded(c)) c.clamp.style.maxHeight = 'none';
      });

      c.toggle.addEventListener('click', function () {
        setClampOpen(item, !clampExpanded(c), true);
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          measureClamp(item);
        }).observe(c.content);
      }

      measureClamp(item);
    }

    function bind(item) {
      if (item.getAttribute(READY_ATTR)) return;

      var p = parts(item);
      if (!p.trigger || !p.panel) return;

      item.setAttribute(READY_ATTR, 'true');

      // Settle to `auto` once an opening transition finishes so the panel can
      // grow with its content on reflow.
      p.panel.addEventListener('transitionend', function (event) {
        if (event.target !== p.panel || event.propertyName !== 'height') return;
        if (item.getAttribute('data-open') === 'true') {
          p.panel.style.height = 'auto';
        }
      });

      p.trigger.addEventListener('click', function () {
        var open = item.getAttribute('data-open') !== 'true';
        if (open) closeSiblings(item, true);
        setOpen(item, open, true);
      });

      setOpen(item, item.getAttribute('data-open') === 'true', false);
      bindClamp(item);
    }

    function bindAll(scope) {
      var container = scope && scope.querySelectorAll ? scope : document;
      Array.prototype.slice
        .call(container.querySelectorAll(ROOT_SELECTOR + ' ' + ITEM_SELECTOR))
        .forEach(bind);
      enforceSingleOpen(container);
    }

    function init() {
      bindAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // The cap changes at the 768px breakpoint, and a width change alone does not
    // always change the content height, so re-measure on resize as well.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        Array.prototype.slice
          .call(document.querySelectorAll(ROOT_SELECTOR + ' ' + ITEM_SELECTOR))
          .forEach(measureClamp);
      }, 150);
    });

    document.addEventListener('shopify:section:load', function (event) {
      bindAll(event.target);
    });

    // Selecting a block in the theme editor reveals it.
    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target.closest && event.target.closest(ITEM_SELECTOR);
      if (!item) return;
      bind(item);
      closeSiblings(item, true);
      setOpen(item, true, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     <fc-pdp-reviews> — the review carousel.

     How many cards fit is measured, not hard-coded per breakpoint: the element
     divides its own width by the card width from the stylesheet. One card
     peeks at the screen edges (the phone design); two or more sit flush, so the
     viewport is capped to exactly that many and no sliver of the next card
     shows. Pages, dots and the arrows all follow from that one number.
     -------------------------------------------------------------------------- */

  class FcPdpReviews extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-fc-reviews-viewport]');
      this.track = this.querySelector('[data-fc-reviews-track]');
      this.slides = Array.from(this.querySelectorAll('[data-fc-reviews-slide]'));

      if (!this.viewport || !this.track || this.slides.length === 0) return;

      this.prevButton = this.querySelector('[data-fc-reviews-prev]');
      this.nextButton = this.querySelector('[data-fc-reviews-next]');
      this.dotsContainer = this.querySelector('[data-fc-reviews-dots]');
      this.controls = this.querySelector('[data-fc-reviews-controls]');

      this.page = 0;
      this.perView = 1;
      this.dots = [];

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);

      this.addEventListener('keydown', this.onKeydown);
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      /* Selecting a block in the theme editor should bring its page forward. */
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.layout(true);
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);

      this.removeEventListener('keydown', this.onKeydown);

      if (this.viewport) {
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('pointercancel', this.onPointerUp);
      }

      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);

      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
    }

    /* ---------------------------------------------------------------- layout */

    /* Card width and gutter are read from the resolved custom properties rather
       than measured, so the maths follows the breakpoint and any merchant size
       change without a second source of truth. */
    get metrics() {
      const styles = getComputedStyle(this);
      const read = (name, fallback) => {
        const value = parseFloat(styles.getPropertyValue(name));

        return isNaN(value) ? fallback : value;
      };

      return {
        cardWidth: read('--fc-rv-card-w', 301),
        gap: read('--fc-rv-gap', 16)
      };
    }

    layout(instant) {
      const { cardWidth, gap } = this.metrics;
      const perView = Math.max(1, Math.floor((this.clientWidth + gap) / (cardWidth + gap)));
      const pages = Math.ceil(this.slides.length / perView);

      this.cardWidth = cardWidth;
      this.gap = gap;
      this.perView = perView;

      /* One card peeks; two or more are flush, so the viewport is pinned to
         exactly the group width and never shows part of the next card. */
      this.viewport.style.maxWidth =
        perView > 1 ? perView * cardWidth + (perView - 1) * gap + 'px' : '';

      if (pages !== this.pages) {
        this.pages = pages;
        this.buildDots();
      }

      /* Every card is already on screen, so there is nowhere to page to: the
         arrows and the dot strip come off with the pill around them. Measured
         rather than counted, because how many fit depends on the viewport. */
      if (this.controls) this.controls.hidden = this.pages <= 1;

      this.goTo(this.page, instant);
    }

    buildDots() {
      if (!this.dotsContainer) return;

      const label = this.dotsContainer.getAttribute('data-dot-label') || '';

      this.dotsContainer.textContent = '';
      this.dots = [];

      /* A lone dot says nothing, so the strip only appears once there is a
         second page to go to. */
      this.dotsContainer.hidden = this.pages <= 1;

      if (this.pages <= 1) return;

      for (let i = 0; i < this.pages; i += 1) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'fc-pdp-reviews__dot';
        dot.setAttribute('aria-label', (label + ' ' + (i + 1)).trim());
        dot.addEventListener('click', () => this.goTo(i));

        this.dotsContainer.appendChild(dot);
        this.dots.push(dot);
      }
    }

    /* ---------------------------------------------------------------- travel */

    goTo(page, instant) {
      const last = Math.max(0, this.pages - 1);

      this.page = Math.min(Math.max(page, 0), last);

      /* The final page is pulled back so it ends flush with the last card,
         rather than leaving a gap where the missing cards would be. */
      const maxFirst = Math.max(0, this.slides.length - this.perView);
      const first = Math.min(this.page * this.perView, maxFirst);
      const groupWidth = this.perView * this.cardWidth + (this.perView - 1) * this.gap;
      const offset =
        first * (this.cardWidth + this.gap) + groupWidth / 2 - this.viewport.clientWidth / 2;

      if (instant) this.classList.add('is-instant');

      this.track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';

      if (instant) {
        /* Flush the jump before motion is allowed again. */
        void this.track.offsetWidth;
        this.classList.remove('is-instant');
      }

      this.sync();
    }

    sync() {
      if (this.prevButton) this.prevButton.disabled = this.page <= 0;
      if (this.nextButton) this.nextButton.disabled = this.page >= this.pages - 1;

      this.dots.forEach((dot, i) => {
        const active = i === this.page;

        dot.classList.toggle('is-active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    onPrev() {
      this.goTo(this.page - 1);
    }

    onNext() {
      this.goTo(this.page + 1);
    }

    onResize() {
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => this.layout(true));
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;

      const slide = event.target.closest('[data-fc-reviews-slide]');

      if (!slide) return;

      this.goTo(Math.floor(this.slides.indexOf(slide) / this.perView));
    }

    /* ----------------------------------------------------------------- input */

    onPointerDown(event) {
      if (event.target.closest('button, a, input')) return;

      this.pointerStart = event.clientX;
    }

    onPointerUp(event) {
      if (this.pointerStart == null) return;

      const distance = event.clientX - this.pointerStart;

      this.pointerStart = null;

      /* 40px of travel separates a swipe from a tap on a card. */
      if (Math.abs(distance) < 40) return;

      this.goTo(this.page + (distance < 0 ? 1 : -1));
    }

    onKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input, textarea, select')) return;

      event.preventDefault();
      this.goTo(this.page + (event.key === 'ArrowRight' ? 1 : -1));
    }
  }

  if (!customElements.get('fc-pdp-reviews')) {
    customElements.define('fc-pdp-reviews', FcPdpReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     FC PDP Sticky CTA

     Reveal: an IntersectionObserver watches the element named by the section's
     trigger selector (the main add-to-cart button by default). The card is
     shown once that element has scrolled up out of the viewport and hidden
     again when it comes back — the shopper never sees two add-to-cart buttons.

     Expand / collapse: "+" toggles .is-expanded; the panel is inert while
     collapsed so nothing inside it can take focus. Escape, a click outside
     the card, or a successful add all collapse it.

     Add to cart: the theme's <product-form> element owns the request — it
     puts .loading on the submit button, renders the mini-cart and publishes
     cartUpdate / cartError. This element only listens: on a successful add
     it waits for .loading to clear and then collapses.

     Variant change: the theme's VariantSelects dispatches variant:change.
     The hidden variant id is updated at once and the section is re-fetched
     so the price, photo and button reflect the new variant.
     -------------------------------------------------------------------------- */

  (function () {
    'use strict';

    if (customElements.get('fc-sticky-cta')) return;

    var VISIBLE_CLASS = 'is-visible';
    var EXPANDED_CLASS = 'is-expanded';
    var REGION_ATTR = 'data-fc-sticky-region';
    var FALLBACK_TRIGGER = '.product-form__submit, .product__info-wrapper';

    class FcStickyCta extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.toggle = this.querySelector('[data-fc-sticky-toggle]');
        this.panel = this.querySelector('[data-fc-sticky-panel]');
        this.form = this.querySelector('form');
        this.submit = this.querySelector('[' + REGION_ATTR + '="submit"]');
        this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;

        this.passedTrigger = false;
        this.pinned = false; // theme editor: section selected
        this.expanded = false;
        this.addSucceeded = false;
        this.fetchController = null;

        this.onToggle = this.handleToggle.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onVariantChange = this.handleVariantChange.bind(this);
        this.onCartUpdate = this.handleCartUpdate.bind(this);
        this.onCartError = this.handleCartError.bind(this);
        this.onSectionSelect = this.handleSectionSelect.bind(this);
        this.onSectionDeselect = this.handleSectionDeselect.bind(this);
        this.onRebuild = this.observeTrigger.bind(this);
        this.onFallbackScroll = this.handleFallbackScroll.bind(this);

        if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('variant:change', this.onVariantChange);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);

        // Sections render in any order, so the trigger may not exist yet.
        window.addEventListener('load', this.onRebuild);
        document.addEventListener('shopify:section:load', this.onRebuild);

        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
          this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
          this.unsubscribeCartError = subscribe(PUB_SUB_EVENTS.cartError, this.onCartError);
        }

        if (this.submit) {
          this.loadingObserver = new MutationObserver(this.handleSubmitMutation.bind(this));
          this.loadingObserver.observe(this.submit, { attributes: true, attributeFilter: ['class'] });
        }

        this.observeTrigger();
      }

      disconnectedCallback() {
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('variant:change', this.onVariantChange);
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        window.removeEventListener('load', this.onRebuild);
        document.removeEventListener('shopify:section:load', this.onRebuild);
        window.removeEventListener('scroll', this.onFallbackScroll);
        if (this.unsubscribeCartUpdate) this.unsubscribeCartUpdate();
        if (this.unsubscribeCartError) this.unsubscribeCartError();
        if (this.loadingObserver) this.loadingObserver.disconnect();
        if (this.triggerObserver) this.triggerObserver.disconnect();
        if (this.fetchController) this.fetchController.abort();
      }

      /* ---- Reveal ---------------------------------------------------------- */

      observeTrigger() {
        var selector = (this.dataset.fcStickyTrigger || '').trim() || FALLBACK_TRIGGER;
        var trigger = null;

        try {
          trigger = document.querySelector(selector);
        } catch (e) {
          trigger = null;
        }
        if (!trigger) trigger = document.querySelector(FALLBACK_TRIGGER);

        if (this.triggerObserver) this.triggerObserver.disconnect();
        window.removeEventListener('scroll', this.onFallbackScroll);

        if (!trigger) {
          // Nothing to watch (e.g. sold-out product with no buy button):
          // reveal after a screen's worth of scrolling instead.
          window.addEventListener('scroll', this.onFallbackScroll, { passive: true });
          this.handleFallbackScroll();
          return;
        }

        this.triggerObserver = new IntersectionObserver(this.handleTrigger.bind(this), { threshold: 0 });
        this.triggerObserver.observe(trigger);
      }

      handleTrigger(entries) {
        var entry = entries[entries.length - 1];
        // "Passed" means the trigger has left through the top of the viewport.
        this.passedTrigger = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.render();
      }

      handleFallbackScroll() {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        this.passedTrigger = scrollY > window.innerHeight;
        this.render();
      }

      render() {
        var visible = this.pinned || this.passedTrigger;
        this.classList.toggle(VISIBLE_CLASS, visible);
        if (!visible && this.expanded) this.setExpanded(false);
      }

      /* ---- Expand / collapse ---------------------------------------------- */

      setExpanded(expanded) {
        if (this.expanded === expanded) return;
        this.expanded = expanded;
        this.classList.toggle(EXPANDED_CLASS, expanded);

        if (this.toggle) {
          this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          var label = expanded ? this.dataset.fcStickyLabelClose : this.dataset.fcStickyLabelOpen;
          if (label) this.toggle.setAttribute('aria-label', label);
        }

        if (this.panel) {
          // inert keeps the collapsed panel out of the tab order and away
          // from assistive tech; it is set after the close animation so the
          // content does not vanish mid-transition.
          if (expanded) {
            this.panel.removeAttribute('inert');
          } else {
            clearTimeout(this.inertTimer);
            this.inertTimer = setTimeout(function () {
              if (!this.expanded && this.panel) this.panel.setAttribute('inert', '');
            }.bind(this), 320);
          }
        }
      }

      handleToggle() {
        this.setExpanded(!this.expanded);
      }

      handleKeydown(event) {
        if (event.key !== 'Escape' || !this.expanded) return;
        this.setExpanded(false);
        if (this.toggle) this.toggle.focus();
      }

      handleDocumentClick(event) {
        if (!this.expanded || this.contains(event.target)) return;
        this.setExpanded(false);
      }

      /* ---- Add to cart ---------------------------------------------------- */

      isOwnRequest(data) {
        // The theme's <product-form> marks whichever submit button it is
        // working for with .loading — only ours means the add came from here.
        return data && data.source === 'product-form' && this.submit && this.submit.classList.contains('loading');
      }

      handleCartUpdate(data) {
        if (this.isOwnRequest(data)) this.addSucceeded = true;
      }

      handleCartError(data) {
        if (this.isOwnRequest(data)) this.addSucceeded = false;
      }

      handleSubmitMutation() {
        if (this.submit.classList.contains('loading') || !this.addSucceeded) return;
        this.addSucceeded = false;
        this.setExpanded(false);
      }

      /* ---- Variant change ------------------------------------------------- */

      handleVariantChange(event) {
        var variant = event.detail && event.detail.variant;
        if (!variant || !this.idInput) return;

        this.idInput.value = variant.id;
        this.refresh(variant.id);
      }

      refresh(variantId) {
        var url = this.dataset.productUrl;
        if (!url || !this.sectionId || typeof fetch !== 'function') return;

        if (this.fetchController) this.fetchController.abort();
        this.fetchController = typeof AbortController === 'function' ? new AbortController() : null;

        var separator = url.indexOf('?') === -1 ? '?' : '&';
        var request = url + separator + 'variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(this.sectionId);

        fetch(request, this.fetchController ? { signal: this.fetchController.signal } : undefined)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            this.querySelectorAll('[' + REGION_ATTR + ']').forEach(function (destination) {
              var name = destination.getAttribute(REGION_ATTR);
              var source = doc.querySelector('[' + REGION_ATTR + '="' + name + '"]');
              if (!source) return;
              destination.innerHTML = source.innerHTML;
              if (name === 'submit') {
                destination.toggleAttribute('disabled', source.hasAttribute('disabled'));
              }
            });
          }.bind(this))
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            console.error(error);
          });
      }

      /* ---- Theme editor --------------------------------------------------- */

      handleSectionSelect(event) {
        if (!event.detail || event.detail.sectionId !== this.sectionId) return;
        this.pinned = true;
        this.render();
        this.setExpanded(true);
      }

      handleSectionDeselect(event) {
        if (!event.detail || event.detail.sectionId !== this.sectionId) return;
        this.pinned = false;
        this.setExpanded(false);
        this.render();
      }
    }

    customElements.define('fc-sticky-cta', FcStickyCta);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     <fc-pdp-ugc> — the UGC carousel.

     The track is positioned with a transform rather than native scrolling,
     because the active slide changes size: a transform lets the resize and the
     travel share one transition instead of fighting the scroll position.

     The carousel loops at every width: a copy of the last posts sits before
     the first and a copy of the first posts after the last, so a move off
     either end travels into identical content and never hits a wall. Once it
     comes to rest inside a clone zone the track teleports (instantly,
     transitions off) to the equivalent real slide — invisible, because the
     content one cycle over is the same. The buffer is sized from the viewport,
     since a wider one shows more of it at once, and the arrows never disable.

     Also owns the per-slide play/pause toggle. Shopify-hosted videos play
     inline; YouTube and Vimeo embeds are only injected on the first play, then
     driven through their postMessage APIs so the same button can pause them.
     -------------------------------------------------------------------------- */

  class FcPdpUgc extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-fc-ugc-viewport]');
      this.track = this.querySelector('[data-fc-ugc-track]');
      this.realSlides = Array.from(this.querySelectorAll('[data-fc-ugc-slide]'));

      if (!this.viewport || !this.track || this.realSlides.length === 0) return;

      this.desktop = window.matchMedia('(min-width: 768px)');
      this.loop = this.realSlides.length > 1;
      this.cloneCount = 0;
      this.slides = this.realSlides;

      if (this.loop) this.buildClones(this.requiredClones());

      this.prevButton = this.querySelector('[data-fc-ugc-prev]');
      this.nextButton = this.querySelector('[data-fc-ugc-next]');

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBreakpoint = this.onBreakpoint.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerUp);
      this.track.addEventListener('transitionend', this.onTransitionEnd);
      this.desktop.addEventListener('change', this.onBreakpoint);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      /* Selecting a block in the theme editor should bring that slide forward. */
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      const start = parseInt(this.getAttribute('data-fc-ugc-start'), 10);

      this.real = isNaN(start) ? 0 : Math.min(Math.max(start, 0), this.realSlides.length - 1);
      this.goTo(this.trackIndex(this.real), true);
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);

      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);

      if (this.viewport) {
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('pointercancel', this.onPointerUp);
      }

      if (this.track) this.track.removeEventListener('transitionend', this.onTransitionEnd);
      if (this.desktop) this.desktop.removeEventListener('change', this.onBreakpoint);

      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);

      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      clearTimeout(this.normaliseTimer);
    }

    /* ------------------------------------------------------------------ loop */

    /* The buffer has to fill the space beside the active slide — otherwise the
       run of posts visibly ends — plus one more for the slide a single move
       travels into. A move that starts inside a clone zone re-seats before it
       travels, so one step is all it ever has to cover.

       Measured rather than fixed because the merchant sets the card widths and
       a desktop viewport shows several slides either side. Two is the floor,
       which is what mobile has always used; twelve is a ceiling, so a nonsense
       width setting cannot run the clone loop away. */
    requiredClones() {
      const { activeWidth, inactiveWidth, gap } = this.metrics;
      const pitch = inactiveWidth + gap;
      const beside = pitch > 0 ? (this.viewport.clientWidth - activeWidth) / 2 / pitch : 0;

      return Math.min(12, Math.max(2, Math.ceil(beside) + 1));
    }

    /* Rebuilds the buffer when the viewport has grown enough to show more of
       it. The count only ever grows, so shrinking the window does no work.
       Answers whether it rebuilt: every index is measured from the first
       clone, so a caller that changed the buffer has to re-seat. */
    growClones() {
      if (!this.loop || this.requiredClones() <= this.cloneCount) return false;

      /* Re-seat off any clone first, so the rebuild cannot drop the card the
         carousel is currently sitting on. */
      this.normalise();
      this.track.querySelectorAll('.fc-pdp-ugc__slide--clone').forEach((clone) => clone.remove());
      this.buildClones(this.requiredClones());
      this.goTo(this.trackIndex(this.real), true);

      return true;
    }

    /* Cloned cyclically, so the buffer still fills with fewer posts than
       clones. */
    buildClones(count) {
      this.cloneCount = count;

      const makeClone = (slide) => {
        const clone = slide.cloneNode(true);

        clone.classList.add('fc-pdp-ugc__slide--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');

        /* A copied id is a duplicate id. The quick-add form is found by
           element, never by id, so dropping them costs nothing. */
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));

        /* Hidden from assistive tech, so nothing inside may take focus. */
        clone.querySelectorAll('a, button, input, video').forEach((el) => {
          el.tabIndex = -1;
        });

        return clone;
      };

      const total = this.realSlides.length;

      for (let i = 0; i < count; i += 1) {
        this.track.insertBefore(makeClone(this.realSlides[total - 1 - (i % total)]), this.track.firstElementChild);
        this.track.appendChild(makeClone(this.realSlides[i % total]));
      }

      this.slides = Array.from(this.querySelectorAll('[data-fc-ugc-slide]'));
    }

    /* The slides the index addresses: the whole track while looping, the real
       posts otherwise — a lone post has no clones to count. */
    get cards() {
      return this.loop ? this.slides : this.realSlides;
    }

    trackIndex(real) {
      return this.loop ? this.cloneCount + real : real;
    }

    /* 0-based index into the real posts, whatever clone zone we are in */
    realIndexOf(index) {
      if (!this.loop) return index;

      const count = this.realSlides.length;

      return (((index - this.cloneCount) % count) + count) % count;
    }

    inCloneZone() {
      if (!this.loop) return false;

      return this.index < this.cloneCount || this.index >= this.cloneCount + this.realSlides.length;
    }

    /* Re-seats a clone-zone index onto the real slide it copies. Nothing on
       screen moves: the track shifts by exactly one cycle, which is the
       distance between equivalent positions whichever slide is active, and the
       active class moves to the twin with motion off so the widths swap in the
       same frame.

       The shift is applied to the live transform rather than to the resting
       position of the index, so calling this in the middle of a transition
       carries on from where the track actually is instead of snapping it to
       the end of the move it was making. */
    normalise() {
      clearTimeout(this.normaliseTimer);

      if (!this.inCloneZone()) return;

      const { inactiveWidth, gap } = this.metrics;
      const cycle = this.realSlides.length * (inactiveWidth + gap);
      const forward = this.index >= this.cloneCount + this.realSlides.length;

      this.index = this.trackIndex(this.real);
      this.activeCard = this.cards[this.index];

      this.classList.add('is-instant');

      this.slides.forEach((slide) => {
        slide.classList.toggle('is-active', slide === this.activeCard);
      });

      this.track.style.transform =
        'translate3d(' + (this.currentTranslate() + (forward ? cycle : -cycle)) + 'px, 0, 0)';

      /* Flush the jump before motion is allowed again. */
      void this.track.offsetWidth;
      this.classList.remove('is-instant');

      this.pauseInactiveVideos();
      this.syncArrows();
    }

    /* The track's transform as it is right now — mid-transition included. */
    currentTranslate() {
      const value = getComputedStyle(this.track).transform;

      if (!value || value === 'none') return 0;

      try {
        return new DOMMatrix(value).m41;
      } catch (error) {
        return 0;
      }
    }

    /* transitionend is the normal trigger; the timer covers the cases where no
       transition runs at all, such as reduced motion. */
    scheduleNormalise() {
      clearTimeout(this.normaliseTimer);

      if (!this.inCloneZone()) return;

      this.normaliseTimer = setTimeout(() => this.normalise(), this.duration + 50);
    }

    onTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform') return;

      this.normalise();
    }

    get duration() {
      const value = getComputedStyle(this).getPropertyValue('--fc-ugc-duration').trim();
      const number = parseFloat(value);

      if (isNaN(number)) return 600;

      return value.endsWith('ms') ? number : number * 1000;
    }

    /* Every relative move goes through here. Starting from a clone zone it
       re-seats first, so a burst of taps can never run past the buffer. */
    move(delta) {
      this.normalise();
      this.goTo(this.index + delta);
    }

    /* ---------------------------------------------------------------- travel */

    goTo(index, instant) {
      const cards = this.cards;
      const next = Math.min(Math.max(index, 0), cards.length - 1);
      const active = cards[next];

      /* Compared by element, not by index: a clone and the real slide it copies
         are two different cards at the same index in different modes. */
      const changed = active !== this.activeCard;

      this.index = next;
      this.real = this.realIndexOf(next);
      this.activeCard = active;

      this.slides.forEach((slide) => {
        slide.classList.toggle('is-active', slide === active);
      });

      if (changed) this.pauseInactiveVideos();

      this.position(instant);
      this.syncArrows();
      this.scheduleNormalise();
    }

    /* Slide widths are transitioned, so the DOM cannot be measured for this.
       A transition starts at the value it is leaving, which means reading
       offsetLeft straight after the active class moves reports the layout we
       are coming from — the track then settles off centre by half the size
       delta. (It looked right on first paint only because that path disables
       transitions before measuring.)

       The geometry is fully described by three custom properties instead:
       every slide except the active one sits at the inactive width, so the
       active slide's centre is exact arithmetic rather than a measurement. */
    get metrics() {
      const styles = getComputedStyle(this);
      const read = (name, fallback) => {
        const value = parseFloat(styles.getPropertyValue(name));

        return isNaN(value) ? fallback : value;
      };

      return {
        activeWidth: read('--fc-ugc-active-w', 307),
        inactiveWidth: read('--fc-ugc-inactive-w', 220),
        gap: read('--fc-ugc-slide-gap', 16)
      };
    }

    position(instant) {
      if (!this.cards[this.index]) return;

      if (instant) this.classList.add('is-instant');

      const { activeWidth, inactiveWidth, gap } = this.metrics;
      const centre = this.index * (inactiveWidth + gap) + activeWidth / 2;
      const offset = centre - this.viewport.clientWidth / 2;

      this.track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';

      if (instant) {
        /* Flush the jump before motion is allowed again. */
        void this.track.offsetWidth;
        this.classList.remove('is-instant');
      }
    }

    /* A loop has no ends, so the arrows only ever go dead on a single post. */
    syncArrows() {
      const bounded = !this.loop;

      if (this.prevButton) this.prevButton.disabled = bounded && this.index <= 0;
      if (this.nextButton) this.nextButton.disabled = bounded && this.index >= this.cards.length - 1;
    }

    onPrev() {
      this.move(-1);
    }

    onNext() {
      this.move(1);
    }

    onResize() {
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      /* growClones re-seats and repositions itself when it rebuilds. */
      this.resizeFrame = requestAnimationFrame(() => {
        if (!this.growClones()) this.position(true);
      });
    }

    /* Crossing the breakpoint swaps Figma's slide sizes, so the resting
       position moves with them — and the wider layout may want a deeper clone
       buffer. The post keeps its place. */
    onBreakpoint() {
      if (!this.growClones()) this.goTo(this.trackIndex(this.real), true);
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;

      const slide = event.target.closest('[data-fc-ugc-slide]');
      const real = slide ? this.realSlides.indexOf(slide) : -1;

      /* Only real slides carry a block, so the clones never match here. */
      if (real >= 0) this.goTo(this.trackIndex(real));
    }

    /* --------------------------------------------------------------- pointer */

    onPointerDown(event) {
      this.suppressClick = false;

      /* The product card is a stretched link over the whole card, so it has to
         stay swipeable — only the real controls opt out of the drag. */
      const control = event.target.closest('button, a, input');

      if (control && !control.hasAttribute('data-fc-ugc-cta-link')) return;

      this.pointerStart = event.clientX;
    }

    onPointerUp(event) {
      if (this.pointerStart == null) return;

      const distance = event.clientX - this.pointerStart;

      this.pointerStart = null;

      /* 40px of travel separates a swipe from a tap on a slide. */
      if (Math.abs(distance) < 40) return;

      /* A swipe that started on the product card still produces a click on the
         link in some browsers — that click must not navigate. */
      this.suppressClick = true;

      this.move(distance < 0 ? 1 : -1);
    }

    /* ----------------------------------------------------------------- input */

    onClick(event) {
      const playButton = event.target.closest('[data-fc-ugc-play]');

      if (playButton) {
        this.togglePlay(playButton);
        return;
      }

      const soundButton = event.target.closest('[data-fc-ugc-sound]');

      if (soundButton) {
        this.toggleSound(soundButton);
        return;
      }

      const cardLink = event.target.closest('[data-fc-ugc-cta-link]');

      if (cardLink) {
        if (this.suppressClick) event.preventDefault();
        this.suppressClick = false;
        return;
      }

      /* Anything interactive keeps its own behaviour — only bare card clicks
         bring a slide forward. */
      if (event.target.closest('button, a, input, product-form')) return;

      const slide = event.target.closest('[data-fc-ugc-slide]');
      const index = slide ? this.cards.indexOf(slide) : -1;

      if (index >= 0) this.goTo(index);
    }

    onKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input, textarea, select')) return;

      event.preventDefault();
      this.move(event.key === 'ArrowRight' ? 1 : -1);
    }

    /* ----------------------------------------------------------------- video */

    togglePlay(button) {
      const media = button.closest('[data-fc-ugc-media]');

      if (!media) return;

      if (media.classList.contains('is-playing')) {
        this.pauseMedia(media);
      } else {
        this.playMedia(media);
      }
    }

    playMedia(media) {
      const type = media.getAttribute('data-fc-ugc-video-type');

      if (type === 'native') {
        const video = media.querySelector('video');

        if (video) {
          const played = video.play();

          /* Autoplay policies reject muted-less playback on some browsers. */
          if (played && typeof played.catch === 'function') played.catch(() => {});
        }
      } else {
        const iframe = media.querySelector('iframe');

        if (iframe) {
          this.command(iframe, type, 'play');
        } else {
          const template = media.querySelector('[data-fc-ugc-embed]');

          if (template) media.appendChild(template.content.cloneNode(true));
        }
      }

      media.classList.add('is-playing');
      this.setPlayState(media, true);
    }

    pauseMedia(media) {
      const type = media.getAttribute('data-fc-ugc-video-type');

      if (type === 'native') {
        const video = media.querySelector('video');

        if (video) video.pause();
      } else {
        const iframe = media.querySelector('iframe');

        if (iframe) this.command(iframe, type, 'pause');
      }

      media.classList.remove('is-playing');
      this.setPlayState(media, false);
    }

    pauseInactiveVideos() {
      this.slides.forEach((slide) => {
        if (slide === this.activeCard) return;

        const media = slide.querySelector('[data-fc-ugc-media].is-playing');

        if (!media) return;

        this.pauseMedia(media);

        /* Moving away is not the same as pausing on purpose: a slide the
           visitor has left goes back to muted, so sound can never come from a
           card that is no longer the one in front of them. */
        this.setMuted(media, true);
      });
    }

    /* --------------------------------------------------------------- sound */

    toggleSound(button) {
      const media = button.closest('[data-fc-ugc-media]');

      if (!media) return;

      const video = media.querySelector('video');

      if (!video) return;

      const unmuting = video.muted;

      this.setMuted(media, !unmuting);

      /* Reaching for the sound on a stopped video means "let me hear it", so
         start playback rather than leaving a silent, still frame. */
      if (unmuting && video.paused) this.playMedia(media);
    }

    setMuted(media, muted) {
      const video = media.querySelector('video');

      if (!video) return;

      video.muted = muted;
      media.classList.toggle('is-unmuted', !muted);

      const button = media.querySelector('[data-fc-ugc-sound]');

      if (!button) return;

      /* Pressed means sound is on; the label always names the next action. */
      const label = muted
        ? button.getAttribute('data-label-unmute')
        : button.getAttribute('data-label-mute');

      button.setAttribute('aria-pressed', muted ? 'false' : 'true');

      if (label) button.setAttribute('aria-label', label);
    }

    /* YouTube and Vimeo both take JSON over postMessage, with different
       payloads. Wrapped because a cross-origin frame can still be loading. */
    command(iframe, type, action) {
      const payload =
        type === 'youtube'
          ? { event: 'command', func: action === 'play' ? 'playVideo' : 'pauseVideo', args: [] }
          : { method: action };

      try {
        iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
      } catch (error) {
        /* Nothing to do — the toggle still reflects the requested state. */
      }
    }

    setPlayState(media, playing) {
      const button = media.querySelector('[data-fc-ugc-play]');

      if (!button) return;

      const label = playing
        ? button.getAttribute('data-label-pause')
        : button.getAttribute('data-label-play');

      button.setAttribute('aria-pressed', playing ? 'true' : 'false');

      if (label) button.setAttribute('aria-label', label);
    }
  }

  if (!customElements.get('fc-pdp-ugc')) {
    customElements.define('fc-pdp-ugc', FcPdpUgc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-press-logo-bar"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     FC Press Logo Bar — auto marquee

     Measures the logo row against its container. If the row is wider than the
     screen it is duplicated and scrolled infinitely; otherwise it stays a
     static centred row exactly as designed. Re-measures on resize, on image
     load and on theme-editor events.
     -------------------------------------------------------------------------- */

  (function () {
    'use strict';

    var ROOT_SELECTOR = '.fc-press-logo-bar';
    var MARQUEE_CLASS = 'fc-press-logo-bar--marquee';
    var CLONE_ATTR = 'data-fc-marquee-clone';

    function prefersReducedMotion() {
      return (
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    function measure(track, items) {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var padding =
        (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0);
      var width = 0;

      items.forEach(function (item, index) {
        width += item.getBoundingClientRect().width;
        if (index > 0) width += gap;
      });

      return { width: width, gap: gap, padding: padding };
    }

    function reset(root, track) {
      root.classList.remove(MARQUEE_CLASS);
      Array.prototype.slice
        .call(track.querySelectorAll('[' + CLONE_ATTR + ']'))
        .forEach(function (clone) {
          track.removeChild(clone);
        });
    }

    function build(root) {
      var viewport = root.querySelector('[data-fc-marquee]');
      var track = root.querySelector('[data-fc-marquee-track]');
      if (!viewport || !track) return;

      reset(root, track);

      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;

      var metrics = measure(track, items);

      // Fits on screen — leave the design untouched.
      if (metrics.width <= viewport.clientWidth - metrics.padding) return;

      root.classList.add(MARQUEE_CLASS);

      // Reduced motion: scrollable row, no auto-scroll, no duplicated content.
      if (prefersReducedMotion()) return;

      var fragment = document.createDocumentFragment();

      items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute(CLONE_ATTR, '');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('fc-animate--in');
        Array.prototype.slice
          .call(clone.querySelectorAll('a'))
          .forEach(function (link) {
            link.setAttribute('tabindex', '-1');
          });
        fragment.appendChild(clone);
      });

      track.appendChild(fragment);

      var speed = parseFloat(root.getAttribute('data-fc-marquee-speed')) || 40;
      if (speed <= 0) speed = 40;

      var duration = (metrics.width + metrics.gap) / speed;
      root.style.setProperty(
        '--fc-press-logo-bar-marquee-duration',
        duration.toFixed(2) + 's'
      );
    }

    function buildAll(scope) {
      var container = scope && scope.querySelectorAll ? scope : document;
      var roots = Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR));
      if (container.nodeType === 1 && container.matches && container.matches(ROOT_SELECTOR)) {
        roots.push(container);
      }
      roots.forEach(build);
    }

    function debounce(fn, wait) {
      var timer;
      return function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(fn, wait);
      };
    }

    function init() {
      buildAll(document);

      // Logos are lazy-loaded, so widths are only final once they decode.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          buildAll(document);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('load', function () {
      buildAll(document);
    });

    window.addEventListener(
      'resize',
      debounce(function () {
        buildAll(document);
      }, 200)
    );

    document.addEventListener('shopify:section:load', function (event) {
      buildAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      buildAll(event.target.closest ? event.target.closest(ROOT_SELECTOR) || document : document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-social-feed"] && !Shopify.designMode) return;
  try {
    
  /* --------------------------------------------------------------------------
     <fc-social-feed> — the customer post carousel.

     Scroll-snap track with dots, prev/next arrows and fading of cards cut off
     by the track edge. The carousel LOOPS: the last two posts are cloned in
     front of the track and the first two behind it, and the start position is
     the first real post — so the very first paint already shows faded
     neighbours on both sides with the first dot active, exactly like the
     Figma. Two mechanisms keep the loop seamless: while scrolling, nearing
     either track edge shifts the position by exactly one cycle (the content
     is identical one cycle over, so the shift is invisible and a momentum
     fling can never slam into the track edge); and once the scroll rests in
     a clone zone it normalises to the equivalent real card.

     The loop is desktop-only. On mobile the Figma wants a real first and
     last card, so the clones are hidden there (CSS) and the track is a plain
     linear slider whose arrows disable at the ends.

     Only the active card's muted video plays: the centred card on desktop,
     the card snapped to the gutter on mobile. Every other card — including
     the faded neighbours either side and the loop clones — stays paused and
     muted, and nothing autoplays at all for visitors who prefer reduced
     motion.
     -------------------------------------------------------------------------- */

  if (!customElements.get('fc-social-feed')) {
    customElements.define('fc-social-feed', class FcSocialFeed extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fc-sf-track]');
        this.realSlides = Array.from(this.querySelectorAll('.fc-social-feed__card'));
        this.dotsWrap = this.querySelector('[data-fc-sf-dots]');
        this.prevButton = this.querySelector('[name="previous"]');
        this.nextButton = this.querySelector('[name="next"]');
        if (!this.track || this.realSlides.length === 0) return;

        this.loop = this.realSlides.length > 1;
        this.cloneCount = 0;
        this.desktop = window.matchMedia('(min-width: 768px)');
        if (this.loop) this.setupLoop();
        this.slides = Array.from(this.querySelectorAll('.fc-social-feed__card'));

        // Crossing the breakpoint swaps loop mode (the clones appear or
        // vanish), so re-seat the scroll on the card we were showing
        this.desktop.addEventListener('change', () => {
          const target = this.loopActive() ? this.cloneCount + this.index : this.index;
          this.jumpTo(this.snapBase() + target * this.slideOffset());
        });

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelectorAll('video').forEach((video) => {
          /* video_tag has no playsinline parameter; without it iOS refuses to
             autoplay and would go fullscreen on play() */
          video.setAttribute('playsinline', '');
          video.muted = true;
          /* The markup autoplays every video so the section still moves
             without JS. With JS, playback belongs to syncPlayback — drop the
             attribute so nothing restarts itself behind its back. */
          video.removeAttribute('autoplay');
        });

        this.buildDots();
        this.onScrollEnd = this.onScrollEnd.bind(this);
        this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        if ('onscrollend' in window) {
          this.track.addEventListener('scrollend', this.onScrollEnd);
        }
        if (this.prevButton) this.prevButton.addEventListener('click', this.scrollBySlide.bind(this, -1));
        if (this.nextButton) this.nextButton.addEventListener('click', this.scrollBySlide.bind(this, 1));

        this.addEventListener('click', this.onControlClick.bind(this));
        // play/pause events do not bubble — capture them instead, so one
        // listener keeps every card's button state in sync with the video,
        // whoever started or stopped it (observer or visitor)
        this.addEventListener('play', this.onMediaEvent.bind(this), true);
        this.addEventListener('pause', this.onMediaEvent.bind(this), true);

        // Cards cut off by the track edge fade (desktop; the visual is scoped
        // to desktop in CSS). Observed against the track so it self-updates
        // while scrolling and resizing. 0.95 rather than 1 tolerates subpixel
        // rounding on fully visible cards. Visibility no longer drives
        // playback — being on screen is not the same as being the card the
        // visitor is looking at, and on desktop three cards are on screen at
        // once. syncPlayback owns that.
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-faded', entry.intersectionRatio < 0.95);
          });
        }, { root: this.track, threshold: [0, 0.95, 1] });
        this.slides.forEach((slide) => this.observer.observe(slide));

        this.update();
      }

      playVideo(video) {
        const played = video.play();
        if (played) played.catch(() => {});
      }

      // The card the carousel is resting on, clones included — on desktop the
      // centred one, on mobile the one snapped to the gutter. Mobile hides the
      // clones, so there the index counts real cards only.
      activeSlide() {
        const cards = this.loopActive() ? this.slides : this.realSlides;
        const index = Math.min(Math.max(this.rawIndex(), 0), cards.length - 1);
        return cards[index];
      }

      // Only the active card plays. Everything else pauses and goes back to
      // muted, so sound can never come from a card the visitor has moved past.
      // A hand-paused card stays paused when it becomes active again, and a
      // card the visitor started by hand keeps playing until the active card
      // changes — the early return leaves untouched whatever they set up.
      syncPlayback() {
        // No active card before the track has been laid out — leave playback
        // alone rather than pausing everything; the first scroll sorts it out
        const active = this.activeSlide();
        if (!active || active === this.activeCard) return;
        this.activeCard = active;

        this.slides.forEach((slide) => {
          const media = slide.querySelector('[data-fc-sf-media]');
          const video = media && media.querySelector('video');
          if (!video) return;

          if (slide !== active) {
            video.pause();
            this.setMuted(media, true);
          } else if (!this.reducedMotion.matches && !media.hasAttribute('data-fc-sf-user-paused')) {
            this.playVideo(video);
          }
        });
      }

      onControlClick(event) {
        const playButton = event.target.closest('[data-fc-sf-play]');
        const soundButton = event.target.closest('[data-fc-sf-sound]');
        if (!playButton && !soundButton) return;

        const media = event.target.closest('[data-fc-sf-media]');
        const video = media && media.querySelector('video');
        if (!video) return;

        if (playButton) {
          // The visitor's choice outlives the observer: a hand-paused video
          // stays paused until they press play again
          if (video.paused) {
            media.removeAttribute('data-fc-sf-user-paused');
            this.playVideo(video);
          } else {
            media.setAttribute('data-fc-sf-user-paused', '');
            video.pause();
          }
          return;
        }

        const unmuting = video.muted;
        this.setMuted(media, !unmuting);
        // Reaching for the sound on a stopped video means "let me hear it",
        // so start playback rather than leaving a silent, still frame
        if (unmuting && video.paused) {
          media.removeAttribute('data-fc-sf-user-paused');
          this.playVideo(video);
        }
      }

      // Syncs the is-playing state and the play button off the video's own
      // events — one source of truth for observer- and visitor-driven changes
      onMediaEvent(event) {
        const media = event.target.closest && event.target.closest('[data-fc-sf-media]');
        if (!media) return;

        const playing = !event.target.paused;
        media.classList.toggle('is-playing', playing);

        const button = media.querySelector('[data-fc-sf-play]');
        if (!button) return;
        const label = playing
          ? button.getAttribute('data-label-pause')
          : button.getAttribute('data-label-play');
        button.setAttribute('aria-pressed', playing ? 'true' : 'false');
        if (label) button.setAttribute('aria-label', label);
      }

      setMuted(media, muted) {
        const video = media.querySelector('video');
        if (!video) return;

        video.muted = muted;
        media.classList.toggle('is-unmuted', !muted);

        const button = media.querySelector('[data-fc-sf-sound]');
        if (!button) return;
        // Pressed means sound is on; the label always names the next action
        const label = muted
          ? button.getAttribute('data-label-unmute')
          : button.getAttribute('data-label-mute');
        button.setAttribute('aria-pressed', muted ? 'false' : 'true');
        if (label) button.setAttribute('aria-label', label);
      }

      setupLoop() {
        // Three per side keeps the wrap thresholds from overlapping at the
        // 1440px cap: the safe zone between them must be at least one cycle
        // (N × pitch) wide, which two clones cannot guarantee on desktop
        this.cloneCount = 3;

        const makeClone = (slide) => {
          const clone = slide.cloneNode(true);
          clone.classList.add('fc-social-feed__card--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('a, button, video').forEach((el) => { el.tabIndex = -1; });
          /* syncPlayback decides playback; a burst of cloned autoplays would
             fight it on load */
          clone.querySelectorAll('video').forEach((video) => video.removeAttribute('autoplay'));
          return clone;
        };

        // Cloned cyclically, so the buffer works even with fewer real posts
        // than clones (a 2-post loop gets r2 r1 r2 | r1 r2 | r1 r2 r1)
        const count = this.realSlides.length;
        for (let i = 0; i < this.cloneCount; i += 1) {
          this.track.insertBefore(makeClone(this.realSlides[count - 1 - (i % count)]), this.track.firstElementChild);
          this.track.appendChild(makeClone(this.realSlides[i % count]));
        }

        // Home = the first real card, snapped — the leading clones fill the
        // left peek so the first paint matches the Figma's balanced view.
        // Mobile needs no jump: it is linear and starts on the first card at
        // scrollLeft 0 anyway. Retried on the next frame if layout has not
        // happened yet (widths read as 0 before the section stylesheet
        // applies).
        if (!this.desktop.matches) return;
        const home = () => this.jumpTo(this.snapBase() + this.cloneCount * this.slideOffset());
        if (this.slideOffset() === 0) window.requestAnimationFrame(home);
        else home();
      }

      // The loop only runs on desktop — on mobile the clones are hidden and
      // the track is linear
      loopActive() {
        return this.loop && this.desktop.matches;
      }

      // scrollLeft at which slide 0 is snapped. Mobile snaps card starts to
      // the gutter (scroll-padding), so slide 0 rests at scrollLeft 0. On
      // desktop cards snap centred, so slide 0 rests where its centre meets
      // the scrollport centre — negative here, but every card's position
      // derives from it as base + index × pitch. Slide 0 means the first
      // VISIBLE card: a clone on desktop, the first real card on mobile.
      snapBase() {
        if (!this.desktop.matches) return 0;
        const first = this.track.querySelector('.fc-social-feed__card');
        return first.offsetLeft + first.offsetWidth / 2 - this.track.clientWidth / 2;
      }

      // Instant, snap-safe reposition (no smooth scroll, no animation)
      jumpTo(left) {
        const previous = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = left;
        this.track.style.scrollBehavior = previous;
      }

      // Measured from the real cards — always visible in both modes (hidden
      // clones report offsetLeft 0)
      slideOffset() {
        if (this.realSlides.length < 2) return this.realSlides[0].offsetWidth;
        return this.realSlides[1].offsetLeft - this.realSlides[0].offsetLeft;
      }

      rawIndex() {
        return Math.round((this.track.scrollLeft - this.snapBase()) / this.slideOffset());
      }

      // 0-based index into the real posts, whatever clone zone we are in
      currentIndex() {
        const count = this.realSlides.length;
        const offset = this.loopActive() ? this.cloneCount : 0;
        return ((this.rawIndex() - offset) % count + count) % count;
      }

      buildDots() {
        if (!this.dotsWrap) return;
        this.dots = this.realSlides.map(() => {
          const dot = document.createElement('span');
          dot.className = 'fc-social-feed__dot';
          this.dotsWrap.appendChild(dot);
          return dot;
        });
      }

      scrollBySlide(direction) {
        this.track.scrollTo({ left: this.snapBase() + (this.rawIndex() + direction) * this.slideOffset() });
      }

      onScroll() {
        if (this.loopActive()) this.wrapEdges();
        window.requestAnimationFrame(this.update.bind(this));

        // Fallback for browsers without the scrollend event
        if (!('onscrollend' in window)) {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(this.onScrollEnd, 150);
        }
      }

      // Nearing either track edge (a hard fling can cross the whole clone
      // buffer before the scroll rests) shifts the position by exactly one
      // cycle. The clones guarantee the content one cycle over is identical,
      // so the shift is invisible — and the edge is simply never reached.
      wrapEdges() {
        const pitch = this.slideOffset();
        if (!pitch) return;
        const cycle = this.realSlides.length * pitch;
        const left = this.track.scrollLeft;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (left < pitch) this.jumpTo(left + cycle);
        else if (left > max - pitch) this.jumpTo(left - cycle);
      }

      // Once the scroll settles inside a clone zone, teleport to the
      // equivalent real card — invisible because clones are exact copies
      onScrollEnd() {
        if (!this.loopActive()) return;
        const raw = this.rawIndex();
        const count = this.realSlides.length;
        if (raw >= this.cloneCount && raw < this.cloneCount + count) return;
        this.jumpTo(this.snapBase() + (this.cloneCount + this.currentIndex()) * this.slideOffset());
      }

      update() {
        const index = this.currentIndex();
        this.index = index;
        if (this.dots) this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));

        this.syncPlayback();

        // A looping carousel has no ends; otherwise -1 tolerates fractional
        // scroll widths
        if (this.loopActive()) return;
        const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;
        if (this.prevButton) this.prevButton.toggleAttribute('disabled', this.track.scrollLeft <= 0);
        if (this.nextButton) this.nextButton.toggleAttribute('disabled', this.track.scrollLeft >= maxScrollLeft);
      }
    });

    // Theme editor: bring the selected post into view
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target && event.target.closest && event.target.closest('.fc-social-feed__card');
      if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
